import useSetting from "components/sidebarComponents/SidebarProject/use-settings";
import { useCallback } from "react";

export const useHeaderActions = () => {
  const {openSideBarHandler} = useSetting()
  const handleSettingsOpen = useCallback(({ accessorKey: currentColumnId } ) => {
    openSideBarHandler(currentColumnId)
  }, [openSideBarHandler]);

  return {
    handleSettingsOpen,
  };
};

export default useHeaderActions;
